import * as React from 'react';
import {useSelector} from 'react-redux';

import {Field, formValueSelector} from 'redux-form';

import {nonNull} from 'shells/form/validation/non-null';
import {ReduxFormSelectPickerGeneric} from 'shells/redux-form-fields/select-picker-generic/select-picker-generic';
import {ReduxFormTextField} from 'shells/redux-form-fields/textfield';
import type {SavedSettingToastState} from 'shells/saved-setting-toast/saved-setting-toast';

import type {EnrollmentFormFieldKey} from 'nutshell-graphql-types';

import type {NutshellState} from '../../../../../store';

import {OWNERSHIP_TYPES, STOCK_EXCHANGE_OPTIONS} from './consts';
import {TEXTFIELD_HEIGHT} from './form';

// This matches the FORM_NAME in enrollment-form.js,
// but importing it is not working for some reason
const formSelector = formValueSelector('sms_enrollment_form');

type Props = {
    handleSave: (key: EnrollmentFormFieldKey, value: string) => void;
    getErrorMessageForField: (key: EnrollmentFormFieldKey) => string | null | undefined;
    saveToastState: SavedSettingToastState;
    isSavingKey: string | null | undefined;
    isDisabled: boolean;
};

export function OwnershipTypeField(props: Props) {
    const {handleSave, getErrorMessageForField, saveToastState, isSavingKey} = props;
    const ownershipType = useSelector((state: NutshellState) => formSelector(state, 'OWNERSHIP'));

    const secondaryFields =
        ownershipType && ownershipType.toLowerCase() === 'public' ? (
            <>
                <Field
                    key='STOCK_EXCHANGE'
                    name='STOCK_EXCHANGE'
                    title='Stock exchange'
                    isRequired={true}
                    validate={[nonNull]}
                    component={ReduxFormSelectPickerGeneric}
                    minHeight={TEXTFIELD_HEIGHT}
                    options={STOCK_EXCHANGE_OPTIONS}
                    onChange={(e, value) => {
                        handleSave('STOCK_EXCHANGE', value);
                    }}
                    errorMessage={getErrorMessageForField('STOCK_EXCHANGE')}
                    saveToastState={isSavingKey === 'STOCK_EXCHANGE' && saveToastState}
                    isDisabled={props.isDisabled}
                />
                <Field
                    key='STOCK_TICKER_SYMBOL'
                    name='STOCK_TICKER_SYMBOL'
                    title='Stock ticker symbol'
                    isRequired={true}
                    validate={[nonNull]}
                    component={ReduxFormTextField}
                    onBlur={(e, value) => {
                        handleSave('STOCK_TICKER_SYMBOL', value);
                    }}
                    errorMessage={getErrorMessageForField('STOCK_TICKER_SYMBOL')}
                    saveToastState={isSavingKey === 'STOCK_TICKER_SYMBOL' && saveToastState}
                />
            </>
        ) : undefined;

    return (
        <>
            <Field
                key='OWNERSHIP'
                name='OWNERSHIP'
                title='Ownership type'
                isRequired={true}
                validate={[nonNull]}
                component={ReduxFormSelectPickerGeneric}
                options={OWNERSHIP_TYPES}
                tooltipInfo='Indicates whether the business is public, private, a non-profit, or governmental organization'
                onChange={(e, value) => {
                    handleSave('OWNERSHIP', value);
                }}
                errorMessage={getErrorMessageForField('OWNERSHIP')}
                saveToastState={isSavingKey === 'OWNERSHIP' && saveToastState}
                isDisabled={props.isDisabled}
            />
            {secondaryFields}
        </>
    );
}
